/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'download-icon': {
    width: 11,
    height: 8,
    viewBox: '0 0 11 8',
    data: '<path pid="0" d="M4.75 4.12V.173h1V4.12l1.09-1.08.703.71L5.25 6.025 2.957 3.75l.704-.71L4.75 4.12zm4.59 2.951V4.957h.91V7.98h-10V4.957h.91V7.07h8.18z" _fill="#376F99" fill-rule="nonzero"/>'
  }
})
